var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosInstance } from 'client/axiosInstance';
import { API_PATHES } from 'client/constants';
import * as React from 'react';
import { extractError } from 'utils/extractError';
export const getServiceRate = (setResult, stateId, caseTypeId) => React.useEffect(() => {
    const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
        setResult({ isFetching: true });
        const axios = axiosInstance();
        try {
            const result = yield axios.post(API_PATHES.places.serviceRate, {
                stateId,
                caseTypeId,
            });
            const { data } = result;
            setResult({ isFetching: false, data });
        }
        catch (e) {
            setResult({ isFetching: false, error: extractError(e, 'Could not read service rate') });
        }
    });
    fetchData();
}, [stateId, caseTypeId]);
